module.exports = __webpack_public_path__ + "static/media/lena1.030c713d.jpg";